/**
 * FinalCTA.jsx
 * ---------------------------------------------------------------------------
 * Section 9. Dark navy closing band with three pathway CTAs and a footer
 * wordmark. Closes the experience the way it opened — with the three-way
 * framing of the platform.
 */

import React from "react";
import { tokens } from "../../lib/tokens.js";

const CTA_ITEMS = [
  { label: "Submit a Case", sub: "For individuals", id: "individuals" },
  { label: "Request Cases", sub: "For firms", id: "firms" },
  { label: "Explore Services", sub: "Enterprise", id: "services" },
];

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function FinalCTA() {
  return (
    <section
      style={{
        background: tokens.ink,
        color: "#fff",
        padding: "140px 32px 64px",
      }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div
          style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: 11,
            letterSpacing: "0.24em",
            textTransform: "uppercase",
            color: "rgba(255,255,255,0.55)",
            marginBottom: 40,
            display: "flex",
            alignItems: "center",
            gap: 14,
          }}
        >
          <span
            style={{
              width: 28,
              height: 1,
              background: "rgba(255,255,255,0.4)",
            }}
          />
          Engage
        </div>
        <h2
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontWeight: 400,
            fontSize: "clamp(40px, 6vw, 72px)",
            lineHeight: 1.05,
            letterSpacing: "-0.015em",
            margin: 0,
            maxWidth: 900,
          }}
        >
          Three pathways.
          <br />
          <em style={{ fontStyle: "italic", color: "#A3BFFA" }}>
            One platform.
          </em>
        </h2>

        <div
          style={{
            marginTop: 80,
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: 0,
            borderTop: "1px solid rgba(255,255,255,0.15)",
          }}
        >
          {CTA_ITEMS.map((c, i) => (
            <button
              key={c.label}
              onClick={() => scrollTo(c.id)}
              style={{
                background: "transparent",
                color: "#fff",
                border: "none",
                borderRight:
                  i < CTA_ITEMS.length - 1
                    ? "1px solid rgba(255,255,255,0.15)"
                    : "none",
                padding: "48px 32px",
                textAlign: "left",
                cursor: "pointer",
                transition: "background 200ms",
              }}
              onMouseEnter={(e) =>
                (e.currentTarget.style.background = "rgba(255,255,255,0.04)")
              }
              onMouseLeave={(e) =>
                (e.currentTarget.style.background = "transparent")
              }
            >
              <div
                style={{
                  fontFamily: "'Inter', sans-serif",
                  fontSize: 11,
                  letterSpacing: "0.2em",
                  textTransform: "uppercase",
                  color: "rgba(255,255,255,0.55)",
                  marginBottom: 16,
                }}
              >
                {c.sub}
              </div>
              <div
                style={{
                  fontFamily: "'Cormorant Garamond', serif",
                  fontSize: 32,
                  fontWeight: 400,
                  letterSpacing: "-0.01em",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "baseline",
                }}
              >
                {c.label}
                <span style={{ fontSize: 18, color: "#A3BFFA" }}>→</span>
              </div>
            </button>
          ))}
        </div>

        {/* Footer */}
        <div
          style={{
            marginTop: 120,
            paddingTop: 40,
            borderTop: "1px solid rgba(255,255,255,0.12)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 24,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
            <svg width="20" height="20" viewBox="0 0 22 22" fill="none" aria-hidden>
              <rect x="0.5" y="0.5" width="21" height="21" stroke="#fff" />
              <line x1="0" y1="11" x2="22" y2="11" stroke="#fff" strokeWidth="0.8" />
              <line x1="11" y1="0" x2="11" y2="22" stroke="#fff" strokeWidth="0.8" />
            </svg>
            <span
              style={{
                fontFamily: "'Cormorant Garamond', serif",
                fontSize: 18,
                letterSpacing: "-0.01em",
              }}
            >
              CaseSignalHQ
            </span>
          </div>
          <div
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: 11,
              letterSpacing: "0.16em",
              textTransform: "uppercase",
              color: "rgba(255,255,255,0.5)",
            }}
          >
            © {new Date().getFullYear()} · Legal Intelligence Platform · Not a
            Law Firm
          </div>
        </div>
      </div>
    </section>
  );
}
